import * as React from "react"

import { cn } from "../../lib/utils"

function Table({ className, ...props }) {
  return (
    <div className="relative w-full overflow-x-auto">
      <table className={cn("w-full caption-bottom text-sm", className)} {...props} />
    </div>
  )
}

function TableHeader({ className, ...props }) {
  return <thead className={cn("[&_tr]:border-b", className)} {...props} />
}

function TableBody({ className, ...props }) {
  return <tbody className={cn("[&_tr:last-child]:border-0", className)} {...props} />
}

function TableRow({ className, ...props }) {
  return <tr className={cn("hover:bg-muted/50 border-b transition-colors", className)} {...props} />
}

function TableHead({ className, noWrap = false, ...props }) {
  return (
    <th
      className={cn(
        "text-muted-foreground h-10 px-2 text-left align-middle font-medium whitespace-normal break-words",
        noWrap && "whitespace-nowrap",
        className
      )}
      {...props}
    />
  )
}

function TableCell({ className, noWrap = false, ...props }) {
  return <td className={cn("p-2 align-middle whitespace-normal break-words", noWrap && "whitespace-nowrap", className)} {...props} />
}

export { Table, TableHeader, TableBody, TableRow, TableHead, TableCell }
